import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询所有未被占用箱子
export function queryAvailableContainerList(params) {
  return request({
    url: URL.railwayExport.queryAvailableContainerList,
    method: 'get',
    params
  })
}

// 调箱校验
export function checkCallContainer(data, jobKey) {
  return request({
    url: URL.railwayExport.checkCallContainer,
    method: 'post',
    data,
    params: { jobKey }
  })
}

// 保存调箱关联
export function saveCallContainer(data, jobKey, branchId, departmentId) {
  return request({
    url: URL.railwayExport.saveCallContainer,
    method: 'post',
    data,
    params: { jobKey, branchId, departmentId }
  })
}

// 清理调箱
export function clearContainer(data, jobKey) {
  return request({
    url: URL.railwayExport.clearContainer,
    method: 'post',
    data,
    params: { jobKey }
  })
}

// 箱管还箱
export function returnBox(params) {
  return request({
    url: URL.railwayExport.returnBox,
    method: 'post',
    params
  })
}

// 箱管订单列表
export function queryContainerList(data) {
  return request({
    url: URL.railwayExport.queryContainerList,
    method: 'post',
    data
  })
}
